import { Dialog } from '@hai/ui-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  onReboot?: VoidFunction;
  onCancel?: VoidFunction;
}

// after form submit, when there is no changes to save so we only prompt for REBOOT NOW / LATER
export const RebootNeededSavedModal: React.FunctionComponent<Props> = ({ onReboot, onCancel }) => {
  const { t } = useTranslation();

  return (
    <Dialog
      headline={t('reboot.savedModal.title')}
      bodyText={t('reboot.savedModal.body')}
      onClose={onCancel}
      show={true}
      buttons={[{ label: t('general.later') }, { label: t('general.reboot'), variant: 'danger', onClick: onReboot }]}
    />
  );
};
